import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Dialog)``;

export const List = styled('ul')`
  padding-inline-start: ${(p) => p.theme.spacing(3)};
  margin: 0;
`;
export const ListItem = styled('li')`
  align-items: center;
`;
